import React, { useEffect, useState } from 'react'
import Layout from '../../layouts/Layout'
import './add-case.scss'
import Step1 from './Step1'
import { Button } from 'reactstrap'
import { ChevronRight, Save } from '@mui/icons-material'
import FormStep from './FormStep'
import Tabs from './Tabs'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import { CircularProgress, Stack } from '@mui/material'


const steps = [Step1, Step2, Step3, Step4, Step5]

export default function AddCase() {

  const [step, setStep] = useState(0)
  const [payload, setPayload] = useState({})
  console.log('payload: ', payload);


  // useEffect(() => {
  //   if (!Object.keys(payload).length) {
  //     const d = localStorage.getItem("payload")
  //     setPayload(JSON.parse(d))
  //   } else {
  //     localStorage.setItem("payload", JSON.stringify(payload))
  //   }
  // }, [step])


  const onChange = (values) => {
    setPayload({ ...payload, ...values })
    setStep(step + 1)
  }

  const props = { onChange, payload }

  const Step = steps[step]

  return (
    <Layout title={'Add Case'} active={'AddCase'}>
      <Tabs />
      {/* <Button onClick={()=> setOpen(true)}>Old Case</Button> */}
      {/* <NewCaseForm caseData={payload} isOpen={open} setIsOpen={setOpen} step={2} caseId={"new"} editData={{}}/> */}

      <div className='case-container'>
        <div className='form'>
          <br />
          <FormStep activeStep={step} />
          <br />
          <Step {...props} />
          <div className='submit-group'>
            <div>
              <Button id='back' onClick={() => setStep(step - 1)} disabled={!step} color="secondary"> <i className="bi bi-caret-left-fill"></i> Back</Button>
            </div>
            {/* <Button color="primary"><Save /> Save</Button> */}
            <Stack direction={"row"} justifyContent={"end"} alignItems={"center"} gap={2}>
              <span style={{ display: "none" }} id='progress'>
                <CircularProgress size={32} />
              </span>
              <Button id='submit' color="primary">{step < 4 ? "Next" : "Submit"} <ChevronRight /></Button>
            </Stack>
          </div>
        </div>
      </div>
      <br />
      <br />
    </Layout>
  )
}
